import { Alert, Card, Col, Row, Statistic, Tag } from "antd";
import { IEligibilityCheck } from "eligibility/models";
import { verdictDisplay, KW_LIMIT, THERM_LIMIT } from "eligibility/utils/verdict";

const passTag = (pass: boolean | null) =>
  pass === null ? null : (
    <Tag color={pass ? "success" : "error"}>{pass ? "PASS" : "OVER"}</Tag>
  );

export const EligibilityResult = ({ check }: { check: IEligibilityCheck }) => {
  const { label, color } = verdictDisplay(check.verdict);
  const { demand, therms, demandFull12 } = check.verdictDetail;

  return (
    <div>
      <Alert
        type={color}
        showIcon
        message={label}
        style={{ marginBottom: 16 }}
        data-testid="verdict-banner"
      />
      {check.demandStatementCount > 0 && !demandFull12 && (
        <Alert
          type="warning"
          banner
          message={`Demand average based on ${check.demandStatementCount} month(s), not a full 12`}
          style={{ marginBottom: 16 }}
        />
      )}
      <Row gutter={16}>
        <Col span={8}>
          <Card>
            <Statistic
              title="12-mo Avg Peak Demand"
              value={demand.value ?? "—"}
              suffix="kW"
            />
            <div>
              limit &lt; {KW_LIMIT} kW {passTag(demand.pass)}
            </div>
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Annual Usage"
              value={therms.value ?? "—"}
              suffix="therms"
            />
            <div>
              limit &lt; {THERM_LIMIT.toLocaleString()} {passTag(therms.pass)}
            </div>
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic title="Statements Read" value={check.statements.length} />
            <div>
              {check.demandStatementCount} demand · {check.gasStatementCount} gas
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
